import React from "react";
import "./MyVIP.css";
import { useNavigate } from "react-router-dom";
import InnerHeader from "../../components/InnerHeader";

const MyVIP = ({userData}) => {
    const navigate = useNavigate();
    return (
        <div className="point-container">
            {/* Header */}
          <InnerHeader title="My VIP"/> 
<div className="vp-pointmain">
            {/* VIP Card */}
            <div className="point-card">
                <div className="point-card-left">
                    <p className="point-vip-label">VIP Points (VP)</p>
                    <h1 className="point-vip-points">{(userData ? userData.vip_coin : "0") }</h1>
                    <p className="point-vip-progress-text">
                        <span>0</span> / 80000
                    </p>
                </div>

                <div className="point-card-right">
                    <div className="point-vip-icon"></div>
                </div>
            </div>

            {/* Progress Bar */}
            <div className="point-progress-bar">
                <div className="point-progress-fill"></div>
            </div>

            {/* Levels */}
            <div className="point-levels">
                <div class="vip-lvl-label " lvl="1"><img class="vip-lvl-label__img" alt="rank1" src="https://img.b112j.com/bj/h5/assets/v3/images/vip/vip-rank/rank1.png?v=1770792598866&amp;source=drccdnsrc" loading="lazy" width={20} /><div class="vip-lvl-label__txt">Normal</div></div>
                <span className="point-level"><img width={16} src="https://img.b112j.com/bj/h5/assets/v3/images/vip/vip-rank/rank2.png?v=1770792598866&source=drccdnsrc"/>Elite I</span>
            </div>

            {/* Buttons */}
            <button className="point-btn-primary" onClick={() => navigate("/vip-rebate")}>VIP Instant rebate</button>
            <button className="point-btn-secondary">Upgrade history</button>
            <button className="point-btn-secondary">Learn more about BJ VIP</button>

            {/* Logo */}
            {/* <div className="point-logo">bj</div> */}
            </div>
        </div>
    );
};

export default MyVIP;
